// extracted by mini-css-extract-plugin
export default {"BrowserPreview":"styles_BrowserPreview__AUPxQ","active":"styles_active__nXMiE","container":"styles_container__DbBCh"};